import React from 'react';
import Select from 'react-select';

const ManholeContainerSummit = ({toggleVisibilityManhole, isVisibleManhole, commentManhole, commentTextAreaRefManhole,
      handleCommentChangeManhole, toggleManholeMarker, manholeMarker,wellSave, ownerWellData, handleChangeOwnerWell, selectedOwnerWell}) => {

  return (
    <React.Fragment>
      <button onClick={toggleVisibilityManhole} className={isVisibleManhole ? 'buttonIsHideDrawer2' : 'buttonIsHideDrawer'} >
        {isVisibleManhole ? 'Колодец: скрыть' : 'Колодец: показать'}
      </button>
      {isVisibleManhole && (
        <div className='divСommunicationsDrawer'>
          <img src='./manhole.png'  width='30' height='30' style={{marginRight: "5px"}}/>
          <label className='textTitleDrawer'>Колодец</label>
          <hr className="horizontalLineDrawer"/>
          <div>
              <select className="selectStyleDrawer" style={{marginTop: "10px"}} value={selectedOwnerWell} onChange={handleChangeOwnerWell} >
                   <option value="">Собственник</option>
                   {ownerWellData.map(ownerWell => (
                      <option key={ownerWell.id} value={`${ownerWell.id}`}>{ownerWell.name}</option>
                   ))}
             </select>

            <hr className="horizontalLineDrawer" style={{marginTop: "10px"}}/>                     
          </div>
          <div >
          
            <textarea
              className='areaDescriptionDrawer'
              placeholder="Комментарий"
              rows={3}
              cols={44}
              value={commentManhole}
              ref={commentTextAreaRefManhole}
              onChange={handleCommentChangeManhole}
            />      
            <button onClick={toggleManholeMarker} className={manholeMarker ? 'buttonIsDrawingDrawer2' : 'buttonIsDrawingDrawer'}>
              {manholeMarker ? 'Завершить' : 'Добавить'}
            </button>
            <button onClick={wellSave} className='buttonSaveDrawer'>Сохранить</button>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default ManholeContainerSummit;